import Constants from 'app/shared/constants';
import StringConstants from 'app/shared/constants/StringConstants';

// analytics
import AnalyticsActions from 'app/shared/actions/AnalyticsActions';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import MultiAnalyticsModule from 'app/shared/MultiAnalyticsModule';

const ACCEPTED_HOST_APPS = ['ios', 'android'];

function getGA() {
    if (typeof window !== 'undefined' && window !== null && typeof window.ga !== 'undefined') {
        return window.ga;
    }

    return false;
}

function getMaInstance() {
    return MultiAnalyticsModule.getInstance();
}


const analyticsUtils = {
    formatCustomDimension(dimension) {
        if (dimension.indexOf('dimension') === -1) {
            return `dimension${dimension}`;
        }
        return dimension;
    },

    getCustomDimensionExperimentName(version = 'control', experimentName) {
        version = version.toLowerCase();
        const shortVersion = version === 'experiment' ? 'exp' : 'ctrl';
        return `${shortVersion}:${experimentName}`;
    },

    setExperimentSlot({
        experimentName, version, brand, slot,
    } = {}) {
        if (!slot) {
            global.TEMPORARY_global_logger.warn('ERROR @setExperimentSlot: slot must be defined');
            return;
        }

        if (slot !== 1 && slot !== 2) {
            global.TEMPORARY_global_logger.warn('ERROR @setExperimentSlot: slot must be either 1 or 2');
            return;
        }

        const { AB_TEST_SLOT1, AB_TEST_SLOT2 } = AnalyticsConstants.Z_CUSTOM_DIMENSION;
        const formatExperimentName = analyticsUtils.getCustomDimensionExperimentName(version, experimentName);
        const dimension = slot === 2 ? AB_TEST_SLOT2 : AB_TEST_SLOT1;

        analyticsUtils.setCustomDimension(
            formatExperimentName,
            dimension,
            brand
        );
    },

    setLabsterExperimentDimension({ experiment, brand } = {}) {
        const {
            experimentName, customDimension, variation,
        } = experiment;

        const formatExperimentName = analyticsUtils.getCustomDimensionExperimentName(variation, experimentName);

        analyticsUtils.setCustomDimension(
            formatExperimentName,
            analyticsUtils.formatCustomDimension(customDimension),
            brand
        );
    },

    track: {
        GAEventV2(gaEventObj, additionalParams = { action: '', label: '', value: '' }) {
            if (typeof additionalParams !== 'object') {
                global.TEMPORARY_global_logger
                    .warn('Please provide additional parameters to track with GA_EVENTS as an object.');
                return null;
            }

            if (!gaEventObj) {
                global.TEMPORARY_global_logger
                    .warn('\n\nError: No valid gaEvent found in AnalyticsConstants#GA_EVENTS\n\n');
                return null;
            }

            return (dispatch, getState) => {
                if (getGA()) {
                    const { pathname } = getState().router.location;

                    const category = additionalParams.category || gaEventObj.category;
                    const action = additionalParams.action || gaEventObj.action;
                    const label = additionalParams.label || gaEventObj.label || pathname;
                    const value = additionalParams.value || gaEventObj.value;

                    // use as an adaptor for now
                    // TODO: remove track.GAEventV2 and update instances to use this.trackEvent
                    analyticsUtils.trackEvent(category, action, label, value);

                    // clear dynamic dimensions
                    analyticsUtils.clearCustomDimension(Constants.Z_CUSTOM_DIMENSION.EVENT_CONTENT);
                }
            };
        },
        optimizelyCTAEvent() {
            window.optimizely = window.optimizely || [];
            window.optimizely.push({
                type: 'event',
                eventName: 'ltleases_cta', // don't change this, the name is stuck due to Optimizely
                tags: {
                    revenue: 0, // Optional in cents as integer (500 == $5.00)
                    value: 0.00, // Optional as float
                },
            });
        },
    },

    clearCustomDimension(dimension) {
        if (!dimension) {
            global.TEMPORARY_global_logger.error('ERROR @clearCustomDimension: dimension must be defined');
            return;
        }

        // TODO: enhance to handle multiple brands
        getMaInstance().getMa().setCustomDimensions({
            name: dimension,
            value: null,
        }, [getMaInstance().getTrackerIds().ua]);
    },

    setMobileAppCustomDimension() {
        if (__CLIENT__) {
            const searchParams = new URLSearchParams(window.location.search);
            const hostApp = searchParams.get('hostApp');

            analyticsUtils.setCustomDimension(
                ACCEPTED_HOST_APPS.includes(hostApp).toString(),
                AnalyticsConstants.GTM_CUSTOM_DIMENSION.IS_MOBILE_APP,
                StringConstants.GA_TRACKERS.gtm,
            );
        }
    },

    // trackerType here is going to be a brand or gtm
    setCustomDimension(value, dimension, trackerType) {
        if (!value) {
            global.TEMPORARY_global_logger.warn('ERROR @setCustomDimension: value must be defined');
            return;
        }

        if (!dimension) {
            global.TEMPORARY_global_logger.warn('ERROR @setCustomDimension: dimension must be defined');
            return;
        }

        if (!trackerType) {
            global.TEMPORARY_global_logger.warn('ERROR @setCustomDimension: trackerType must be defined');
            return;
        }

        let trackerId = null;

        switch (trackerType) {
            case Constants.UNFORMATTED_BRAND_NAMES.zillow:
                trackerId = getMaInstance().getTrackerIds().ua;
                break;

            case StringConstants.GA_TRACKERS.gtm:
                trackerId = getMaInstance().getTrackerIds().gtm;
                break;

            default:
                global.TEMPORARY_global_logger.info('No case for', trackerType);
                break;
        }

        getMaInstance().getMa().setCustomDimensions({
            name: dimension,
            value,
        }, [trackerId]);
    },

    // this corresponds to the comet_event in gtm
    trackEvent(category, action, label, value) {
        getMaInstance().getMa().trackEvent({
            category,
            action,
            label,
            value,
        });
    },

    // this corresponds to the send command in ua, and the comet_page_view_event in gtm
    trackPageView(path) {
        return (dispatch) => {
            if (!path) {
                global.TEMPORARY_global_logger.error('ERROR @trackPageView: path must be defined');
                return;
            }
            getMaInstance().getMa().trackPageView({
                path,
            }, null, () => dispatch(AnalyticsActions.comscore()));
        };
    },

    appendSuffix(textToAddSuffixTo, suffix) {
        return textToAddSuffixTo + suffix;
    },
};

export default analyticsUtils;
